import { Link } from '@lt/components';
import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from '@lt/localization';
import { LAW_LINK } from './constants';

const CustomerBlockHeader = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Header>
      <Title>{t('checkout.customer.title')}</Title>
      <Description>
        <Trans
          i18nKey="checkout.customer.description"
          components={{ Link: <Link href={LAW_LINK} /> }}
        />
      </Description>
    </Header>
  );
};

const Header = styled.div`
  padding: 0px 8px;
  margin-bottom: 16px;
`;

const Description = styled.div`
  font-size: 14px;
`;

const Title = styled.div`
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;

  margin-bottom: 8px;
`;

export default CustomerBlockHeader;
